<template>
  <MRow :gutter="0" class="mt-2">
    <MCol :size="3">
      <FlotoCITypePicker
        v-if="moduleName === $constants.CMDB"
        :value="value.ciTypeId"
        :disabled="disabled"
        @change="handleChange({ ciTypeId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="$tc('ci_type')"
            :icon-name="slotData.getIconName(slotData.currentItem)"
            :disabled="disabled"
          >
            <template v-slot:icon>
              <AssetTypeIcon :ci-type-id="value.ciTypeId" size="lg" />
            </template>
          </FlotoDropdownTrigger>
        </template>
      </FlotoCITypePicker>
      <FlotoAssetTypePicker
        v-else
        :value="value.assetTypeId"
        :available-asset-type="getAssetTypeSystemName[value.model]"
        :disabled="disabled"
        @change="handleChange({ assetTypeId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="$tc('asset_type')"
            :icon-name="slotData.getIconName(slotData.currentItem)"
            :disabled="disabled"
          >
            <template v-slot:icon>
              <AssetTypeIcon :asset-type-id="value.assetTypeId" size="lg" />
            </template>
          </FlotoDropdownTrigger>
        </template>
      </FlotoAssetTypePicker>
    </MCol>
    <MCol v-if="moduleName !== $constants.ASSET_CONSUMABLE" :size="3">
      <FlotoStatusPicker
        v-if="moduleName === $constants.CMDB"
        :value="value.ciStatusId"
        :placeholder="disabled ? '---' : undefined"
        :disabled="disabled"
        :module-name="$constants.CMDB"
        @change="handleChange({ ciStatusId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="$t('status')"
            icon-name="status"
            :disabled="disabled"
          />
        </template>
      </FlotoStatusPicker>
      <FlotoStatusPicker
        v-else
        :value="value.statusId"
        :placeholder="disabled ? '---' : undefined"
        :disabled="disabled"
        :module-name="$constants.ASSET"
        @change="handleChange({ statusId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="$t('status')"
            icon-name="status"
            :disabled="disabled"
          />
        </template>
      </FlotoStatusPicker>
    </MCol>
    <MCol v-if="moduleName !== $constants.ASSET_CONSUMABLE" :size="3">
      <FlotoImpactPicker
        :placeholder="disabled ? '---' : undefined"
        :value="value.impactId"
        :disabled="disabled"
        @change="handleChange({ impactId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="$t('impact')"
            icon-name="impact"
            :disabled="disabled"
          />
        </template>
      </FlotoImpactPicker>
    </MCol>
    <MCol :size="3">
      <ProductPicker
        :as-input="false"
        :value="value.productId"
        :disabled="Boolean(disabled || value.softwareLicenseId)"
        :placeholder="disabled ? '---' : '---'"
        @change="handleChange({ productId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="{
              ...slotData,
              ...(Object.keys(slotData.currentItem || {}).length
                ? {
                    currentItem: {
                      ...slotData.currentItem,
                      lable: `${(slotData.currentItem || {}).name}: ${
                        (slotData.currentItem || {}).text
                      }`,
                    },
                  }
                : {}),
            }"
            :lable="$tc('product')"
            custom-icon
            icon-name="product"
            :disabled="disabled"
          />
        </template>
      </ProductPicker>
    </MCol>
  </MRow>
</template>

<script>
import { getAssetTypeSystemName } from '@modules/asset/helpers/asset-type'
import ProductPicker from '@components/data-picker/product-picker'
import AssetTypeIcon from '@components/custom-icon/asset-type-icon.vue'

export default {
  name: 'PrimaryRow',
  components: {
    ProductPicker,
    AssetTypeIcon,
  },
  model: {
    event: 'change',
  },
  props: {
    disabled: { type: Boolean, default: false },
    value: { type: Object, required: true },
    moduleName: { type: String, required: true },
  },
  data() {
    this.getAssetTypeSystemName = getAssetTypeSystemName
    return {}
  },
  methods: {
    handleChange(change) {
      this.$emit('change', change)
    },
  },
}
</script>
